import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const checkInCalEventInputSchema = z.object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
});
//# sourceMappingURL=check-in-cal-event-input.js.map